import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
    selector: '[app-toast-component]',
    styleUrls: ['./toast.component.scss'],
    templateUrl: './toast.component.html',
    animations: [
        trigger('flyInOut', [
            state('inactive', style({
                opacity: 0,
            })),
            transition('inactive => active', animate('400ms ease-out', keyframes([
                style({
                    transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
                    opacity: 0,
                }),
                style({
                    transform: 'skewX(20deg)',
                    opacity: 1,
                }),
                style({
                    transform: 'skewX(-5deg)',
                    opacity: 1,
                }),
                style({
                    transform: 'none',
                    opacity: 1,
                }),
            ]))),
            transition('active => removed', animate('400ms ease-out', keyframes([
                style({
                    opacity: 1,
                }),
                style({
                    transform: 'translate3d(100%, 0, 0) skewX(30deg)',
                    opacity: 0,
                }),
            ]))),
        ]),
    ],
    preserveWhitespaces: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastComponent extends Toast {
  readonly message = signal(this.toastPackage.message ?? '');

  toastTypeIcons: Record<string, { src: string; fill: string }> = {
    'toast-info': { src: '/assets/icons/exclamation.svg', fill: '#4075FF' },
    'toast-success': { src: '/assets/icons/check.svg', fill: '#41C87F' },
    'toast-error': { src: '/assets/icons/close.svg', fill: '#ff7d51' },
    'toast-warning': { src: '/assets/icons/exclamation.svg', fill: '#ff7d51' }
  };

  toastIcon: { src: string; fill: string } | null = null;

  ngOnInit(): void {
    this.toastIcon = this.toastTypeIcons[this.toastPackage.toastType] || null;
  }

  setMessage(message: string): void {
    this.message.set(message);
  }
}
